import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, maxTags: Number, autosave: Boolean }

  connect() {
    this.tagify = new window.Tagify(this.element, {
      whitelist: [],
      maxTags: this.hasMaxTagsValue && this.maxTagsValue > 0 ? this.maxTagsValue : undefined
    })
    this.tagify.on("input", this.onInput.bind(this))
    if (this.autosaveValue) this.tagify.on("add remove", this.onChange.bind(this))
    this.beforeCache = this.destroyTagify.bind(this)
    document.addEventListener("turbo:before-cache", this.beforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCache)
    this.destroyTagify()
  }

  destroyTagify() {
    if (this.tagify) { this.tagify.destroy(); this.tagify = null }
  }

  onInput(event) {
    const value = event.detail.value
    this.tagify.whitelist = null
    if (this.abortController) this.abortController.abort()
    this.abortController = new AbortController()
    this.tagify.loading(true)
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("value", value)
    fetch(url, { signal: this.abortController.signal })
      .then(res => res.json())
      .then(whitelist => {
        this.tagify.whitelist = whitelist
        this.tagify.loading(false).dropdown.show(value)
      })
      .catch(() => {})
  }

  onChange() {
    // Tagify writes the hidden input on a debounce, so read its state directly before submitting.
    this.element.value = JSON.stringify(this.tagify.value.map(item => item.value))
    if (this.element.form) this.element.form.requestSubmit()
  }
}
